import { User, WebStorageStateStore } from "oidc-client-ts";
import { AuthProviderProps } from "react-oidc-context";
import config from "../../config";

/**
 * OpenID Connect configuration
 *
 * Documentation:
 * https://github.com/authts/oidc-client-ts/blob/main/docs/index.md
 * https://github.com/authts/react-oidc-context?tab=readme-ov-file#documentation
 *
 * Example:
 * https://github.com/gary-archer/oauth.websample2/blob/master/spa/src/plumbing/oauth/authenticator.ts
 */
export const oidcConfig: AuthProviderProps = {
  authority: config.keycloakUrl,
  client_id: config.keycloakClientId,
  redirect_uri: config.authRedirectUrl,
  client_secret: config.keycloakClientSecret,
  // scope: "openid profile email roles", // seems to be generated Keycloak-side
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onSigninCallback: (_user: User | void): void => {
    window.history.replaceState({}, document.title, window.location.pathname);
  },
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  monitorSession: true, // this allows cross tab login/logout detection
  // Refresh token handling
  automaticSilentRenew: true,
  // Enfore the login prompt and skip silent authentication (if the user has previously granted consent to the application and has an active session)
  // Doc: https://www.cerberauth.com/openid-connect-prompts
  // Note: only "none" and "login" are supported by Keycloak ???
  // prompt: "login",
};
